export default {"src":"/_next/static/media/SWKS.be9306bb.svg","height":18,"width":18};